<template>
    <div class="orgDetail flex-sub">
        <div class="left-box">
            <LeftPage :active="6"/>
        </div>
        <div class="right-box">
            <div class="table-box">
                <div class="title">
                    <div class="icon-box">
                        <i class="iconfont icon-mima"></i>
                    </div>
                    <b>密码管理</b>
                </div>
               <div class="content  flex flex-direction">
                   <el-form ref="ruleForm" v-loading="loading" :model="ruleForm" :rules="rules" class="ruleFormYan margin-top-xs" label-width="auto">
                       <el-form-item ref="old_password" class="input-container" label="旧密码" prop="old_password">
                           <el-input v-model="ruleForm.old_password" placeholder="请输入旧密码" type="password"></el-input>
                       </el-form-item>
                       <el-form-item ref="new_password" class="input-container" label="新密码" prop="new_password">
                           <el-input v-model="ruleForm.new_password" placeholder="请输入新密码" type="password"></el-input>
                       </el-form-item>
                       <el-form-item ref="confirm_password" class="input-container" label="确认密码" prop="confirm_password">
                           <el-input v-model="ruleForm.confirm_password" placeholder="请输入确认密码" type="password"></el-input>
                       </el-form-item>
                   </el-form>
                   <el-button :loading="submit_loading" class="btn max round margin-tb-sm self-center"
                              type="warning" @click="submitForm('ruleForm')">
                       确认修改
                   </el-button>
               </div>
            </div>
        </div>
    </div>
</template>
<script>
import LeftPage from "@/views/home/common/leftPage";
import rules from "@/utils/rules";
import {logout, scrollIntoView} from "@/utils/utils";
import {edit_pass} from "@/api";

export default {
    name: "password",
    data() {
        const validatePassSame = (rule, value, callback) => {
            if (value !== this.ruleForm.new_password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                old_password: '',//旧密码
                new_password: '',//新密码
                confirm_password: '',//确认密码
            },
            rules: {
                old_password: [
                    {required: true, message: '请输入旧密码', trigger: 'blur'},
                ],
                new_password: [
                    {required: true, message: '请输入新密码', trigger: 'blur'},
                    rules.password
                ],
                confirm_password: [
                    {required: true, message: '请输入确认密码', trigger: 'blur'},
                    {validator: validatePassSame, trigger: 'change'}
                ]
            },
            loading: false,
            submit_loading: false,
        }
    },
    components: {LeftPage},
    computed: {},
    created() {
        this.$emit("setActive", {
            headActive: 2
        })
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid, validates) => {
                if (valid) {
                    this.updatePassword()
                } else {
                    scrollIntoView(this, validates)
                }
            });
        },
        async updatePassword() {
            this.submit_loading = true
            let _data = await edit_pass(
                this.ruleForm.old_password,
                this.ruleForm.new_password,
            )
            this.submit_loading = false
            if (_data.status === 200) {
                this.$message.success('修改成功，请重新登录')
                logout()
            } else {
                this.$message.error(_data.msg)
            }
        },
    },
    watch: {},
    filters: {}
}
</script>

<style lang="scss" scoped>
.red {
    color: #f61919;
}

.orgDetail {
    width: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;
    padding: 20px;
    display: flex;
    justify-content: flex-start;

    .title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 25px;
        border-bottom: 1px solid #e3e7f0;

        b {
            font-size: 22px;
            color: #16181d;
            font-weight: bold;
            margin-left: 10px;
        }

        .icon-box {
            width: 30px;
            height: 30px;
            background-image: linear-gradient(-30deg,
                #3579fb 0%,
                #44a3ff 100%);
            box-shadow: 0px 10px 10px 0px rgba(50, 150, 255, 0.3);
            border-radius: 10px;
            text-align: center;
            line-height: 30px;

            i {
                font-size: 20px;
                color: #ffffff;
            }
        }
    }
}
.left-box {
  width: 260px;
}
.right-box {
    flex: 1;
    margin-left: 25px;
    width: 100%;
    height: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;

    .table-box {
        width: 100%;
        background-image: linear-gradient(0deg,
            #ffffff 84%,
            #edf6ff 100%);
        padding: 30px 20px 0;
        border-radius: 10px;
        .content{
            width: 50%;
        }
    }
}
</style>


